import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SessionWrapperService } from '../session/session-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class Auth2Service {
  private oAuthService = inject(OAuthService);
  private router = inject(Router);

  tokenRecieved = new Subject<boolean>();

  constructor(private sessionService: SessionWrapperService) {
   
    
    this.initConfiguration();
  }
  
  initConfiguration() {
     console.log("environment", environment);
    //TabMSHR
    const authConfig: AuthConfig = {
      issuer: environment.issuer,
      strictDiscoveryDocumentValidation: false,
      clientId: environment.clientId,
      redirectUri: environment.redirectUri,
      scope: environment.scope,
      oidc: true,
      requestAccessToken: false,
      skipIssuerCheck: true,
      responseType: 'code',
      tokenEndpoint: environment.tokenEndpoint,
      postLogoutRedirectUri: environment.post_logout_redirect_uri
      //post_logout_redirect_uri: post_logout_redirect_uri ==>checl the correct name
    };

    this.oAuthService.configure(authConfig);
    this.oAuthService.setupAutomaticSilentRefresh();
    this.oAuthService.loadDiscoveryDocumentAndTryLogin().then(response => {
      console.log('Auth Response', response);
      console.log('Access Token:', this.oAuthService.getAccessToken());
      this.tokenRecieved.next(true);

      
      
    }).catch(error => {
      console.log('Auth Error', error);
      //
    });
  }

  login() {
    this.oAuthService.initLoginFlow();
  }

  logout() {
    this.oAuthService.revokeTokenAndLogout();
    this.oAuthService.logOut();
    this.sessionService.clearSession();
    //this.router.navigate(['/authentication-1/login']);
  }

  getProfile() {
    const profile = this.oAuthService.getIdentityClaims();
    return profile;
  }

  getToken() {
    return this.oAuthService.getAccessToken();
  }

  hasValidAccessToken() {
    return this.oAuthService.hasValidAccessToken();
  }

}
